import * as React from 'react';

import { ItemTableData, ItemTableDataRow } from 'components/ItemTable/ItemTableData';
import { Location } from 'types/location.type';
import { getGLPropertyTableBodyFields } from './GLPropertyTableBodyFields';
import { LocationOptionsData } from 'types/types.type';
import GLPropertyTableRowModel from './GLPropertyTableRowModel';

export default class GLPropertyTableDataBuilder {
    static build(
        classes: any,
        locations: Location[],
        locationOptions: LocationOptionsData,
        handleChange: (value: string, id: string) => void,
        handleShowHTMLTableClick: (rowData: GLPropertyTableRowModel) => void,
        tableData: any,
        readonly: boolean,
        isLocationProRataEndorsement: boolean,
        isLocationRenewal: boolean,
        effectiveDate: string,
        expirationDate: string
    ): ItemTableData {
        const headerFields = [
            {
                value: 'Location',
                style: { textAlign: 'left' } as React.CSSProperties,
            },
            { value: 'Class' },
            { value: 'Agg Limit' },
            { value: 'Occ Limit' },
            { value: 'HNO Limit' },
            { value: 'DED' },
            { value: 'Exp Base Rated Premium', isHidden: readonly || !isLocationRenewal },
            { value: 'Exp IRPM', isHidden: readonly || !isLocationRenewal },
            { value: 'Base Rated Premium' },
            { value: '# Units' },
            { value: '# Pools' },
            {
                value: 'Score',
                style: { textAlign: 'center' } as React.CSSProperties,
            },
            { value: 'Score IRPM' },
            { value: 'IRPM' },
            { value: 'Blended Per Door' },

            // { value: 'Premium' },
            { value: 'TRIA' },
            { value: isLocationProRataEndorsement ? 'Annualized Premium' : 'Total Premium' },
            {
                value: 'Endorsement Premium',
                isHidden: !isLocationProRataEndorsement,
            },
            { value: 'Insp' },
        ].filter((r) => !r.isHidden);

        return {
            header: {
                key: 'propertyReviewHeader',
                fields: headerFields,
            },
            body: locations
                .map((location) => {
                    const matchingRowData =
                        tableData.find((entry: any) => entry && entry.rowId.toString() === location.id.toString()) ||
                        null;
                    // The below test will in effect filter out all locations that don't have matching data IF
                    // A. we are not readonly (underwriting), but the location is deleted, so defaults for all non deleted
                    // B. we are readonly, no matching data after underwriting wouldn't make sense to show defaults

                    // If we are not readonly we don't want to show any markedAsDeleted locations
                    // If we are readonly we don't want to show locations without matchingRowData
                    if ((!readonly && location.markedAsDeleted) || (readonly && !matchingRowData)) {
                        return {} as ItemTableDataRow;
                    }
                    return {
                        key: location.id.toString(),
                        fields: getGLPropertyTableBodyFields({
                            location,
                            locationOptions,
                            matchingRowData: matchingRowData || {},
                            classes,
                            readonly,
                            isLocationRenewal: isLocationRenewal,
                            isLocationProrataEndorsement: isLocationProRataEndorsement,
                            handleChange,
                            handleShowHTMLTableClick,
                            effectiveDate,
                            expirationDate,
                        }),
                        markedAsDeleted: location.markedAsDeleted,
                    } as ItemTableDataRow;
                })
                .filter((l) => !!l.key), // filter out any object that has no data, see above
        };
    }
}
